import { useMemo, useState } from 'react';

import { useSearch } from '@/hooks/useSearch';

import { flattenAndSortSearchResults } from './utils';

export const useTickerSearch = (initialSearchQuery: string | null) => {
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery || '');

  const { data, status } = useSearch(searchQuery);

  const listings = useMemo(
    () => flattenAndSortSearchResults(data, searchQuery),
    [data, searchQuery]
  );

  return {
    searchQuery,
    setSearchQuery,
    listings,
    status,
  };
};
